<app-shared-dialog
  [title]="'companies_groups.filter.title' | translate"
  [options]="{
    titleIcon: 'filter_icon',
    cancelText: 'common.cancel' | translate,
    cancelButtonStyle: 'secondary-btn',
    middleText: 'filter.reset_filters' | translate,
    middleIcon: 'rollback',
    middleButtonStyle: 'secondary-btn',
    confirmText: 'common.apply' | translate,
    confirmButtonStyle: 'primary',
    size: 'large'
  }"
  (cancel)="close()"
  (middle)="resetFilters()"
  (confirm)="apply()"
>
  <div class="filter-form">
    <!-- Row 1: Name + Number of locations (min / max) -->
    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'companies_groups.filter.fields.name' | translate }}</label>
        <input
          type="text"
          [(ngModel)]="filter.groupInfoFilter.name"
          [placeholder]="'companies_groups.filter.fields.name' | translate"
        />
      </div>
      <div class="standard-input">
        <label>{{ 'companies_groups.filter.fields.nbr_locations' | translate }}</label>
        <div class="min-max-row">
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.groupInfoFilter.nbr_locations_min"
            [placeholder]="'common.min' | translate"
          />
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.groupInfoFilter.nbr_locations_max"
            [placeholder]="'common.max' | translate"
          />
        </div>
      </div>
    </div>

    <!-- Row 2: Locations multi-select (full-width) -->
    <div class="filter-row">
      <div class="chip-field">
        <label>{{ 'companies_groups.filter.fields.locations' | translate }}</label>
        <mat-chip-list #locationsChipList class="chip-input">
          <mat-chip
            *ngFor="let location of filter.groupInfoFilter.locations; index as i"
            (removed)="removeLocation(i)">
            {{ location.name }}
            <button matChipRemove>
              <mat-icon style="color: #868e96">cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            class="input_chip"
            #locationsTrigger="matAutocompleteTrigger"
            [placeholder]="'companies_groups.filter.fields.locations' | translate"
            (input)="filterLocations()"
            [(ngModel)]="locationFilterKey"
            [ngModelOptions]="{ standalone: true }"
            [matAutocomplete]="locationsAutoComplete"
            [matChipInputFor]="locationsChipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          />
        </mat-chip-list>
        <mat-autocomplete
          #locationsAutoComplete="matAutocomplete"
          (opened)="onLocationsPanelOpened()"
          (closed)="onLocationsPanelClosed()">
          <mat-option
            *ngFor="let location of filterlocations"
            [value]="location.id"
            (click)="selectLocation(location)">
            {{ location.name }}
          </mat-option>
          <mat-option *ngIf="isLocationsLoadingMore" disabled class="locations-loader-option">
            <div class="locations-loader">
              <span class="locations-spinner"></span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>

    <!-- Row 3: Total orders amount + Total orders count -->
    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'companies_groups.filter.fields.total_orders_amount' | translate }}</label>
        <div class="min-max-row">
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.advancedFilter.total_orders_amount_min"
            [placeholder]="'common.min' | translate"
          />
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.advancedFilter.total_orders_amount_max"
            [placeholder]="'common.max' | translate"
          />
        </div>
      </div>
      <div class="standard-input">
        <label>{{ 'companies_groups.filter.fields.total_orders_count' | translate }}</label>
        <div class="min-max-row">
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.advancedFilter.total_orders_count_min"
            [placeholder]="'common.min' | translate"
          />
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.advancedFilter.total_orders_count_max"
            [placeholder]="'common.max' | translate"
          />
        </div>
      </div>
    </div>
  </div>
</app-shared-dialog>
